import { createSelector } from 'reselect'

export const getMangos = createSelector([
  state => state.mangos
], (mangos) => (
  mangos
))

export const isMangosLoaded = createSelector([ getMangos ], (mangos) => {
  return mangos && Object.keys(mangos).length
})

export const nameToPath = (state, name) => {
  name = mangoName(state, name)
  const path = state.mangos[name]
  if (!isMangosLoaded(state)) return
  if (pathToName(state, name) === name) return name
  if (Object.keys(state.mangos).includes(path)) {
    return state.mangos[path]
  } else {
    return path
  }
}

export const isValidMango = (state, name) => {
  if (!isMangosLoaded(state)) return
  return !!state.mangos[name]
}

export const pathToName = (state, path) => {
  if (typeof state !== 'object') throw new TypeError('no state')
  if (!isMangosLoaded(state)) return

  return Object.keys(state.mangos).find(key => {
    return state.mangos[key] === path
  })
}

export const mangoName = (state, name) => {
  if (typeof state !== 'object') throw new TypeError('no state')
  if (!isMangosLoaded(state)) return
  if (!isValidMango(state, name)) return name
  const path = state.mangos[name]
  if (state.mangos[path]) return path
  return name
}

export const mangoDefaultName = (state) => {
  if (typeof state !== 'object') throw new TypeError('no state')
  if (!state.mangos) return ''
  if (!Object.keys(state.mangos).length) return ''
  return state.mangos.default || ''
}

export const isInitialised = (state, { mango = 'default' }) => {
  mango = mangoName(state, mango)
  if (!isMangosLoaded(state)) return false
  return state.schemas.mango === mango
}

export const getSchemas = createSelector([
  state => state.mangoSchemas,
  (state, { mango }) => mangoName(state, mango)
], (mangoSchemas, mango) => (
  mangoSchemas[mango]
))

export const getMangosByLink = createSelector([
  getMangos
], (mangos) => (
  Object.entries(mangos).reduce((o, [key, value]) => (
    Object.assign(o, {
      [value.link]: key
    })
  ), {})
))



// WEBPACK FOOTER //
// ../webmango-core/selectors/mangoxml.js